import moment from 'moment';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { searchApplicants, addDrivingLessonEntries, getApplicantById } from 'service/api';
import { I18n } from 'react-redux-i18n';
import { showModal } from './modal';
import { matchCourse } from '../util/SearchUtil';

// Constants - action names
export const CHANGE_PAGE = 'pv-kultu/drivingLessons/CHANGE_PAGE';
export const UPDATE_LESSONS = 'pv-kultu/drivingLessons/UPDATE_LESSONS';
export const UPDATE_LESSON_PAUSES = 'pv-kultu/drivingLessons/UPDATE_LESSON_PAUSES';
export const UPDATE_SEARCH_TERMS = 'pv-kultu/drivingLessons/UPDATE_SEARCH_TERMS';
export const FIND_APPLICANTS = 'pv-kultu/drivingLessons/FIND_APPLICANTS';
export const FIND_APPLICANTS_SUCCESS = 'pv-kultu/drivingLessons/FIND_APPLICANTS_SUCCESS';
export const FIND_APPLICANTS_FAILED = 'pv-kultu/drivingLessons/FIND_APPLICANTS_FAILED';
export const RESET = 'pv-kultu/drivingLessons/RESET';
export const UPDATE_APPLICANTS = 'pv-kultu/drivingLessons/UPDATE_APPLICANTS';

export const ADD_ENTRIES = 'pv-kultu/drivingLessons/ADD_ENTRIES';
export const ADD_ENTRIES_SUCCESS = 'pv-kultu/drivingLessons/ADD_ENTRIES_SUCCESS';
export const ADD_ENTRIES_FAILED = 'pv-kultu/drivingLessons/ADD_ENTRIES_FAILED';
export const RESET_APPLICANTS = 'pv-kultu/drivingLessons/RESET_APPLICANTS';
export const RESET_LESSON_ENTRIES = 'pv-kultu/drivingLessons/RESET_LESSON_ENTRIES';

export const FIND_APPLICANT_LESSONS = 'pv-kultu/drivingLessons/FIND_APPLICANT_LESSONS';
export const FIND_APPLICANT_LESSONS_SUCCESS = 'pv-kultu/drivingLessons/FIND_APPLICANT_LESSONS_SUCCESS';
export const FIND_APPLICANT_LESSONS_FAILURE = 'pv-kultu/drivingLessons/FIND_APPLICANT_LESSONS_FAILURE';
export const UPDATE_APPLICANT_SEARCH_TERMS = 'pv-kultu/drivingLessons/UPDATE_APPLICANT_SEARCH_TERMS';

// Helpers

// Initial state
const initialState = {
  page: 'APPLICANTS',
  lessons: [],
  saved: undefined,
  applicants: undefined,
  loading: {
    applicants: false,
    saving: false,
    lessons: false
  },
  error: {
    applicants: undefined,
    saving: undefined
  },
  applicantLessons: [],
  applicantSearchTerms: {
    courseNumber: '',
    courseUnit: '',
    courseYear: moment().format('YYYY'),
    team: '',
    applicantName: ''
  },
  searchTermsUpdated:false
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FIND_APPLICANTS:
      return Object.assign({}, state, {
        loading: {applicants: true}
      });
    case FIND_APPLICANTS_SUCCESS:
      return Object.assign({}, state, {
        loading: {applicants: false},
        applicants: action.applicants
      });
    case FIND_APPLICANTS_FAILED:
      return Object.assign({}, state, {
        loading: {applicants: false},
        error: {applicants: action.error},
      });
    case UPDATE_LESSONS:
      return Object.assign({}, state, { lessons: action.lessons });
    case UPDATE_LESSON_PAUSES:
      return {
        ...state,
        lessons: state.lessons.map(lesson => lesson.id === action.lessonKey ?
            { ...lesson, lessonPauses: action.lessonPauses } :
            lesson
        )
      };

    case UPDATE_APPLICANTS:
      return Object.assign({}, state, {
        applicants: action.applicants
      });
    case ADD_ENTRIES:
      return Object.assign({}, state, {
        loading: {saving: true}
      });
    case ADD_ENTRIES_SUCCESS:
      return Object.assign({}, state, {
        loading: {saving: false},
        saved: true
      });
    case ADD_ENTRIES_FAILED:
      return Object.assign({}, state, {
        loading: {saving: false},
        saved: false,
        error: {saving: action.error},
      });
    case RESET_APPLICANTS:
      return Object.assign({}, state, {
        applicants: initialState.applicants,
        page: initialState.page,
        applicantSearchTerms: initialState.applicantSearchTerms,
        searchTermsUpdated:false
      });
    case CHANGE_PAGE:
      return Object.assign({}, state, {
        page: action.page
      });
    case RESET:
      return initialState;
    case RESET_LESSON_ENTRIES:
      return Object.assign({}, state, {lessons: initialState.lessons});
    case FIND_APPLICANT_LESSONS:
      return Object.assign({}, state, {loading: {lessons: true}});
    case FIND_APPLICANT_LESSONS_SUCCESS:
      return Object.assign({}, state, { applicantLessons: action.applicantLessons });
    case FIND_APPLICANT_LESSONS_FAILURE:
      return Object.assign({}, state, {
        loading: {lessons: false},
        error: {lessons: action.error},
      });
    case UPDATE_APPLICANT_SEARCH_TERMS:
      return Object.assign({}, state, {applicantSearchTerms : Object.assign({}, state.applicantSearchTerms, action.searchTerms), searchTermsUpdated: true});

    default:
      return state;
  }
}

// Actions
export function updateLessonsAction(data) {
  return {type: UPDATE_LESSONS, lessons: data};
}

export function updateLessonPausesAction(data) {
  return {type: UPDATE_LESSON_PAUSES, lessonPauses: data.lessonPauses, lessonKey: data.lessonKey};
}

export function findApplicantsAction(payload) {
  return {type: FIND_APPLICANTS, payload};
}

export function findApplicantsSuccess(data) {
  return {type: FIND_APPLICANTS_SUCCESS, applicants: data};
}

export function findApplicantsFailed(error) {
  return {type: FIND_APPLICANTS_FAILED, error};
}

export function updateApplicants(data) {
  return {type: UPDATE_APPLICANTS, applicants: data};
}

export function resetDrivingLessons() {
  return {type: RESET};
}

export function changePage(page) {
  return {type: CHANGE_PAGE, page};
}

export function addEntries(payload) {
  return {type: ADD_ENTRIES, payload}
}

export function addEntriesSuccess() {
  return {type: ADD_ENTRIES_SUCCESS}
}

export function addEntriesFailed(error) {
  return {type: ADD_ENTRIES_FAILED, error}
}

export function resetDrivingApplicants() {
  return {type: RESET_APPLICANTS};
}

export function findApplicantLessonsAction(payload) {
  return {type: FIND_APPLICANT_LESSONS, payload};
}

export function findApplicantLessonsSuccess(data) {
  return {type: FIND_APPLICANT_LESSONS_SUCCESS, applicantLessons: data};
}

export function findApplicantLessonsFailed(error) {
  return {type: FIND_APPLICANTS_FAILED, error};
}

export function resetLessonEntriesAction() {
  return {type: RESET_LESSON_ENTRIES}
}

export function updateApplicantSearchTermsAction(searchTerms) {
  return {type: UPDATE_APPLICANT_SEARCH_TERMS, searchTerms: searchTerms}
}

// Sagas
export function* handleFindApplicantsSaga(action) {
  try {
    const options = {
      contentType: 'application/json',
      queryParams: {
        drivingLessonTable: true
      }
    };
    const payload = Object.assign({}, action.payload, {
      lessonType: 'DRIVING',
      applicantLessonStatus: 'ACTIVE',
    });
    const data = yield call(searchApplicants, payload, options);
    yield put(findApplicantsSuccess(data));
    if (!!data && data.length > 0) {
      yield put(changePage('APPLICANTS'));
    } else {
      const modalProps = {
        messageType: 'ERROR',
        message: I18n.t('message.no_applicants_found')
      };
      yield put(showModal('MESSAGE', modalProps));
    }
  } catch (error) {
    yield put(findApplicantsFailed(error));
  }
}

export function* handleAddEntriesSaga(action) {
  try {
    const parsedLessons = parseLessonData(action.payload.lessons);
    action.payload.lessons = parsedLessons;
    const options = {
      contentType: 'application/json'
    };
    yield call(addDrivingLessonEntries, {course: action.payload.course, applicants: action.payload.applicants, lessons: parsedLessons}, options);
    yield put(addEntriesSuccess());
    const modalProps = {
      messageType: 'SUCCESS',
      message: I18n.t('message.add_entries_success')
    };
    yield put(showModal('MESSAGE', modalProps));
    yield put(resetDrivingLessons());
  } catch (error) {
    yield put(addEntriesFailed({error: 'ERR_ADD_ENTRIES'}));
    const modalProps = {
      messageType: 'ERROR',
      message: I18n.t('message.add_entries_failed')
    };
    yield put(showModal('MESSAGE', modalProps));
  }
}

export function* handleFindApplicantLessonsSaga(action) {
  try {
    const options = {
      contentType: 'application/json',
    };

    const data = yield call(getApplicantById, action.payload.applicantId, options);
    const lessons = data.applicantLessons.filter(applicantLesson => (!action.payload.course || matchCourse(action.payload.course)(applicantLesson.course)) && applicantLesson.status === "ACTIVE" && (applicantLesson.lesson.lessonType === "DRIVING" || applicantLesson.lesson.lessonType === "PRO_DRIVING"))
    .map(applicantLessons => applicantLessons.lesson);
    yield put(findApplicantLessonsSuccess(lessons));
  
  } catch (error) {
    yield put(findApplicantLessonsFailed({error: 'ERR_FIND_APPLICANT_LESSONS'}));
    if (error.message === 'Unauthorized') {
      yield put(showModal('LOGIN'));
    }
    else {
      const modalProps = {
        messageType: 'ERROR',
        message: I18n.t('message.no_lessons_found')
      };
      yield put(showModal('MESSAGE', modalProps));
    }
  }
}

function* watchDrivingLessons() {
  yield takeEvery(FIND_APPLICANTS, handleFindApplicantsSaga);
  yield takeEvery(ADD_ENTRIES, handleAddEntriesSaga);
  yield takeEvery(FIND_APPLICANT_LESSONS, handleFindApplicantLessonsSaga);
}

export function* drivingLessonsSagas() {
  yield all([
    watchDrivingLessons(),
  ]);
}

// Helper function
function parseLessonData (lessons) {
  if(!!lessons) {
    return lessons.map(lesson => {
      const lessonDateString = lesson.lessonDate.format('YYYY-MM-DD');

      return {
        lessonStartTime: moment(`${lessonDateString} ${lesson.startTime.replace('.', ':')}`, 'YYYY-MM-DD HH:mm').valueOf(),
        lessonEndTime: moment(`${lessonDateString} ${lesson.endTime.replace('.', ':')}`, 'YYYY-MM-DD HH:mm').valueOf(),
        additionalInfo: lesson.additionalInfo,
        beneficialDriving: lesson.beneficialDriving,
        examClass: lesson.class,
        kilometrage: lesson.kilometrage,
        plateNumber: lesson.plateNumber,
        lessonType: lesson.subject.lessonType,
        lessonId: lesson.subject.lessonId,
        selected: lesson.subject.selected,
        entityId: lesson.subject.entityId,
        description: lesson.subject.description,
        drivingTopicCodes: lesson.drivingTopicCodes,
        lessonPauses: lesson.lessonPauses.map((lp) => {
          return {
            lessonPauseType: lp.selectedPauseType,
            pauseStartTime: moment(`${lessonDateString} ${lp.pauseStartTime.replace('.', ':')}`, 'YYYY-MM-DD HH:mm').valueOf(),
            pauseEndTime: moment(`${lessonDateString} ${lp.pauseEndTime.replace('.', ':')}`, 'YYYY-MM-DD HH:mm').valueOf()
          }
        })
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/ducks/drivingLessons.js